var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Select, MenuItem, FormControl, InputLabel, Tooltip, } from "@mui/material";
import useAuth from "../../App/hooks/useAuth";
import { setClarityTag } from "../../App/utils/clarity";
function SubscriberActionsDropdown(_a) {
    var _b, _c, _d;
    var isDropdownOpen = _a.isDropdownOpen, setIsDropdownOpen = _a.setIsDropdownOpen, selectedAction = _a.selectedAction, selectedProductName = _a.selectedProductName, setSelectedProductName = _a.setSelectedProductName, setSelectedAction = _a.setSelectedAction, setSelectedProduct = _a.setSelectedProduct, setShowProducts = _a.setShowProducts, showProducts = _a.showProducts, contentSuppliers = _a.contentSuppliers, selectService = _a.selectService, activeProducts = _a.activeProducts, activeSubscriber = _a.activeSubscriber, hasServicesForResendEmail = _a.hasServicesForResendEmail, navbarRef = _a.navbarRef, isUpdate = _a.isUpdate, _e = _a.type, type = _e === void 0 ? "action" : _e;
    var _f = useState(false), isMobile = _f[0], setIsMobile = _f[1];
    var auth = useAuth().auth;
    var dropdownRef = useRef(null);
    var didSelectRef = useRef(false);
    useEffect(function () {
        var checkMobile = function () {
            setIsMobile(window.innerWidth <= 768);
        };
        checkMobile();
        window.addEventListener("resize", checkMobile);
        return function () { return window.removeEventListener("resize", checkMobile); };
    }, []);
    var actionLabels = {
        activate: "Ativar",
        suspend: "Suspender",
        cancel: "Cancelar",
        reactivate: "Reativar",
        resend: "Reenviar",
    };
    var actions = React.useMemo(function () {
        var checkPermissions = function (p) { return auth.permissions.includes(p); };
        var permissionMap = {
            activate: "active-product",
            reactivate: "active-product",
            cancel: "deactivate-product",
            suspend: "suspend-product",
        };
        if (isUpdate) {
            return Object.entries(actionLabels)
                .filter(function (_a) {
                var key = _a[0];
                var isManualExclude = key === "cancel" || key === "resend";
                var hasPerm = permissionMap[key] ? checkPermissions(permissionMap[key]) : true;
                return !isManualExclude && hasPerm;
            })
                .map(function (_a) {
                var key = _a[0], label = _a[1];
                return ({ key: key, label: label, actionValue: key });
            });
        }
        else {
            var actionsPt = [
                { key: "activate", label: "Ativar" },
                { key: "suspend", label: "Suspender" },
                { key: "cancel", label: "Cancelar" },
                { key: "reactivate", label: "Reativar" },
            ];
            return actionsPt
                .filter(function (item) {
                var permissions = permissionMap[item.key];
                return permissions ? checkPermissions(permissions) : true;
            })
                .map(function (item) { return ({
                key: item.key,
                label: item.label,
                actionValue: item.label,
            }); });
        }
    }, [isUpdate, auth.permissions]);
    function getActionLabel(action) {
        var _a;
        if (isUpdate) {
            return (_a = actionLabels[action]) !== null && _a !== void 0 ? _a : action;
        }
        return action;
    }
    var productsForSelectedService = (_c = (_b = contentSuppliers
        .find(function (supplier) { return supplier.id === Number(selectService); })) === null || _b === void 0 ? void 0 : _b.content_supplier_products.filter(function (product) {
        return activeProducts.some(function (p) { return p.id === product.id; }) &&
            product.active &&
            product.promotion === 0;
    })) !== null && _c !== void 0 ? _c : [];
    function handleSelect(actionValue, productId, productName) {
        var _a;
        setClarityTag("actionType", "subscribers-select-action-".concat(actionValue));
        didSelectRef.current = true;
        setSelectedAction(actionValue);
        setSelectedProduct(productId.toString());
        setIsDropdownOpen(false);
        setSelectedProductName(productName);
        setShowProducts(null);
        (_a = dropdownRef.current) === null || _a === void 0 ? void 0 : _a.click();
    }
    var canResendEmail = !!activeSubscriber && (hasServicesForResendEmail === null || hasServicesForResendEmail === void 0 ? void 0 : hasServicesForResendEmail(activeSubscriber));
    var resendTooltipText = canResendEmail
        ? "Reenviar e-mail de ativação"
        : "Não é possível reenviar porque o assinante não possui serviços ativos";
    var handleMobileActionChange = function (event) {
        var actionValue = event.target.value;
        setSelectedAction(actionValue);
        setIsDropdownOpen(false);
        setShowProducts(null);
    };
    var handleMobileProductChange = function (event) {
        var _a = event.target.value.split("|"), productIdStr = _a[0], productName = _a[1];
        var productId = parseInt(productIdStr);
        setSelectedProduct(productId.toString());
        setSelectedProductName(productName);
        setIsDropdownOpen(false);
        setShowProducts(null);
    };
    if (isMobile) {
        var hasValue = type === "action" ? !!selectedAction : !!selectedProductName;
        return (_jsxs(FormControl, __assign({ fullWidth: true, className: "mobile-mui-select ".concat(hasValue ? "has-selection" : "no-selection"), variant: "outlined" }, { children: [_jsx(InputLabel, __assign({ id: "".concat(type, "-label") }, { children: type === "action" ? "Ação" : "Produto" })), _jsxs(Select, __assign({ labelId: "".concat(type, "-label"), displayEmpty: true, value: type === "action"
                        ? selectedAction || ""
                        : selectedProductName
                            ? "".concat((_d = activeProducts.find(function (p) { return p.name === selectedProductName; })) === null || _d === void 0 ? void 0 : _d.id, "|").concat(selectedProductName)
                            : "", IconComponent: KeyboardArrowDownIcon, label: hasValue ? (type === "action" ? "Ação" : "Produto") : "", onChange: type === "action" ? handleMobileActionChange : handleMobileProductChange, className: !hasValue ? "is-placeholder" : "is-selected", renderValue: function (selected) {
                        if (!selected || selected === "") {
                            return (_jsx("span", __assign({ style: { color: "rgba(0, 0, 0, 0.4)" } }, { children: type === "action" ? "Selecionar uma ação" : "Selecionar um produto" })));
                        }
                        var displayLabel = typeof selected === "string" && selected.includes("|")
                            ? selected.split("|")[1]
                            : selected;
                        return (_jsx("span", __assign({ style: { color: "#003682", fontWeight: 500 } }, { children: displayLabel })));
                    } }, { children: [type === "action"
                            ? actions.map(function (act) { return (_jsx(MenuItem, __assign({ value: act.actionValue, className: "menu-item-black" }, { children: act.label }), act.key)); })
                            : productsForSelectedService.map(function (product) { return (_jsx(MenuItem, __assign({ value: "".concat(product.id, "|").concat(product.name), className: "menu-item-black" }, { children: product.name }), product.id)); }), type === "action" && !isUpdate && activeSubscriber && (hasServicesForResendEmail === null || hasServicesForResendEmail === void 0 ? void 0 : hasServicesForResendEmail(activeSubscriber)) && (_jsx(MenuItem, __assign({ value: "Reenviar", className: "menu-item-black" }, { children: "Reenviar e-mail de ativa\u00E7\u00E3o" })))] }))] })));
    }
    // DESKTOP
    return (_jsxs(Navbar, __assign({ expand: "lg", className: "dropdown-to-provision-subscribers" }, { children: [_jsx(Navbar.Toggle, { "aria-controls": "basic-navbar-nav", ref: navbarRef, "data-id": "subscribers-grid" }), _jsx(Navbar.Collapse, __assign({ id: "basic-navbar-nav", className: isDropdownOpen ? "dropdown-open" : "" }, { children: _jsx(Nav, __assign({ className: "flex-column" }, { children: _jsxs(NavDropdown, __assign({ ref: dropdownRef, title: _jsxs("div", __assign({ id: "nav-dropdown-title", style: {
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                            } }, { children: [_jsx("span", __assign({ style: { flexGrow: 1 } }, { children: selectedAction && selectedProductName
                                        ? "".concat(getActionLabel(selectedAction), " ").concat(selectedProductName.toUpperCase())
                                        : "Selecione uma ação" })), isDropdownOpen ? (_jsx(KeyboardArrowUpIcon, {})) : (_jsx(KeyboardArrowDownIcon, {}))] })), onToggle: function (isOpen) {
                            setIsDropdownOpen(isOpen);
                            if (!isOpen) {
                                if (!didSelectRef.current) {
                                    setShowProducts(null);
                                }
                                didSelectRef.current = false;
                            }
                        } }, { children: [actions.map(function (_a) {
                                var key = _a.key, label = _a.label, actionValue = _a.actionValue;
                                return (_jsxs(NavDropdown.Item, __assign({ as: "div", onClick: function (e) {
                                        setShowProducts(label);
                                        e.preventDefault();
                                        e.stopPropagation();
                                    }, className: "dropdown-item", style: {
                                        backgroundColor: showProducts === label ? "#E0E4F0" : undefined,
                                        color: showProducts === label ? "#000" : undefined,
                                        cursor: "pointer",
                                        position: "relative",
                                    } }, { children: [_jsx("div", __assign({ style: {
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                            } }, { children: _jsx("span", { children: label }) })), showProducts === label && productsForSelectedService.length > 0 && (_jsx("div", __assign({ className: "product-options-submenu", onClick: function (e) { return e.stopPropagation(); }, style: {
                                                position: "absolute",
                                                right: "100%",
                                                left: "auto",
                                                top: "0",
                                                backgroundColor: "#fff",
                                                border: "1px solid #ccc",
                                                borderRadius: "4px",
                                                boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                                                minWidth: "200px",
                                                zIndex: 1050,
                                                maxHeight: "300px",
                                                overflowY: "auto",
                                            } }, { children: productsForSelectedService.map(function (product) { return (_jsx("div", __assign({ onClick: function () { return handleSelect(actionValue, product.id, product.name); }, style: {
                                                    padding: "8px 12px",
                                                    cursor: "pointer",
                                                }, className: "product-item" }, { children: product.name }), product.id)); }) })))] }), key));
                            }), !isUpdate && (_jsx(Tooltip, __assign({ title: resendTooltipText, placement: "top", arrow: true }, { children: _jsx("span", { children: _jsx(NavDropdown.Item, __assign({ disabled: !canResendEmail, onClick: function () {
                                            if (!canResendEmail)
                                                return;
                                            handleSelect("Reenviar", 0, "e-mail de ativação");
                                        } }, { children: "Reenviar e-mail de ativa\u00E7\u00E3o" })) }) })))] })) })) }))] })));
}
export default SubscriberActionsDropdown;
